import { render, staticRenderFns } from "./CallbackView.vue?vue&type=template&id=2ef5d998&scoped=true"
import script from "./CallbackView.vue?vue&type=script&lang=ts"
export * from "./CallbackView.vue?vue&type=script&lang=ts"
import style0 from "./CallbackView.vue?vue&type=style&index=0&id=2ef5d998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef5d998",
  null
  
)

export default component.exports